import {createUseStyles} from 'react-jss';

export default createUseStyles({
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: '90px 50px 0',
    flexDirection: 'column',
  
    '& section': {
      marginBottom: 50,
      width: '100%',
      maxWidth: 900,
      marginTop: 10,
      border: '2px solid rgba(0,0,0,0.3)',
      borderRadius: 5,
      padding: 20,
      display: 'flex',
      flexWrap: 'wrap',
      '& label': {
        margin: '5px 10px',
        width: '100%', 
        maxWidth: 300
      }
    },
    
  },

  imgBox: {
    width: 100,
    height: 100,
    border: '2px solid rgba(0,0,0,0.7)',
    color: "rgba(0,0,0,0.7)",
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 50,
    overflow: 'hidden',
    cursor: 'pointer',
    transition: '0.5s',
    position: 'relative',
    marginRight: 30,
    marginBottom: 20,
    '& input': {
      height: '100%',
      width: '100%',
      position: 'absolute',
      opacity: 0,
      zIndex: 2,
      cursor: 'pointer'
    },
    '&:hover': {
      borderColor: '#004f9f'
    },
    '& img': {
      height: '150%',
      width: '150%',
      zIndex: 1,
    }
  },
  characterArea: {
    width: 100,
    height: 100,
    border: '2px solid rgba(0,0,0,0.7)',
    margin: 5,
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,
    cursor: 'pointer',
    '&.selected': {
      borderColor: '#004f9f'
    },
    '& img': {
      width: '130%',
      height: '130%'
    }
  },

  allChars: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    flexWrap: 'wrap'
  },

  rightInfo: {
    width: 'calc(100% - 130px)',
    display: 'flex',
    flexWrap: 'wrap',
    padding: '0 20px',
  },

  settingsHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    maxWidth: 900,
    flexWrap: 'wrap',
    marginBottom: 30,
    '& h2': {

    }
  },

  saveButton: {
    width: 'auto',
    padding: '0 20px'
  },
  chngpwd: {
    width: 'auto',
    padding: '0 20px'
  },
  cngpwdc: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end'
  },

  '@media screen and (max-width: 800px)': {
    
    container: {
      padding: '90px 10px 0 10px'
    }
  
  },
  '@media screen and (max-width: 500px)': {
    
    rightInfo: {
      width: '100%'
    },
    cngpwdc: {
      justifyContent: 'center',
    },
    container: {
      
      '& section': {
        justifyContent: 'center',
        '& label': {
          width: '100% !important', 
        }
      },
    },
  
  },
})